export default __webpack_public_path__ + "./fonts/verified.5d87c2f9a14b1ba24f9b0cf44a7910a4.svg";